import React from 'react';
import PropTypes from 'prop-types';
import parseV3000SumFormula from '@Utils/React/MolFiletoFormula';

function StructureThumbnail({ enableThumbnail, thumbnailPath, structure }) {
  const formula = parseV3000SumFormula(structure);
  const imgOnDragStart = (e) => {
    e.preventDefault();
  };

  if (!enableThumbnail) {
    return (
      <svg className="els-btn-icon els-btn-icon-md svg-icon">
        <use xlinkHref="#icon-structure" />
      </svg>
    );
  }

  if (enableThumbnail && !thumbnailPath) {
    return null;
  }

  const altText = formula && formula.trim() ? `Linear formula of ${formula}` : 'chemical structure';
  return <img alt={altText} src={thumbnailPath} draggable="false" onDragStart={imgOnDragStart} />;
}

StructureThumbnail.propTypes = {
  enableThumbnail: PropTypes.bool,
  thumbnailPath: PropTypes.string,
  structure: PropTypes.string,
};

export default StructureThumbnail;
